import type { EntityConfigDefinition, DisplayColumnConfig } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'APPLICATION_EXECS',
  idField: 'APPLICATION_EXEC_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['APPLICATION_EXEC_ID'],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['APPLICATION_ID'],
    stringMatchFields: ['APPLICATION_ID'],
    stringMatchThreshold: 0.50,
    displayFields: ['APPLICATION_EXEC_ID', 'APPLICATION_ID', 'AWS_EXEC_ID', 'CREATED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Foreign key lookups
  foreignKeys: {
    "APPLICATION_ID": {
      "table": "APPLICATION",
      "valueField": "APPLICATION_ID",
      "displayField": "ORIGIN_APPLICATION_ID"
    }
  },
  
  // Field lookups for display enhancement
  fieldLookups: {
    "APPLICATION_ID": {
      "lookupTable": "APPLICATION",
      "foreignKey": "APPLICATION_ID",
      "displayField": "ORIGIN_APPLICATION_ID",
      "displayFormat": "{APPLICATION_ID}: {ORIGIN_APPLICATION_ID}"
    }
  },
  
  // Fields configuration
  fields: [
    "APPLICATION_EXEC_ID",
    "APPLICATION_ID",
    "AWS_EXEC_ID",
    "CREATED_DATE"
  ],
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'APPLICATION_ID',
      lookup: {
        table: 'APPLICATION',
        foreignKey: 'APPLICATION_ID',
        displayField: 'ORIGIN_APPLICATION_ID'
      }
    }
  ] as DisplayColumnConfig[],

  // Form fields configuration
  formFields: [
    {
      "name": "APPLICATION_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "AWS_EXEC_ID",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

